"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TreeFactory", {
  enumerable: true,
  get: function get() {
    return _tree["default"];
  }
});

var _tree = _interopRequireDefault(require("./tree"));

require("./index.less");